import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Row, Col, Button } from "reactstrap/lib";
import { FormattedMessage } from "react-intl";

export default function SupervisorInfoModal(props) {
  return (
    <Modal isOpen={props.isOpen} toggle={props.toggle}>
      <ModalHeader toggle={props.toggle}>{props.supervisor.name}</ModalHeader>
      <ModalBody>
        <Row>
          <Col lg={3}>
            <label><FormattedMessage id="Company"/>:</label>
            <br />
            <label><FormattedMessage id="PhoneNumber" />:</label>
            <br />
            <label><FormattedMessage id="Email"/>:</label>
          </Col>
          <Col>
            <label>{props.supervisor.aplCompany.name}</label>
            <br />
            <label>{props.supervisor.phone}</label>
            <br />
            <label>{props.supervisor.email.includes("_apl_spv") ? props.supervisor.email.replace("_apl_spv", "") : props.supervisor.email}</label>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={props.toggle}>
          <FormattedMessage id="Close"/>
        </Button>
      </ModalFooter>
    </Modal>
  );
}
